import { Outlet } from 'react-router-dom';
import { useDesign } from '@app/hooks';
import { ListIntents } from '@app/page-components/intent/ListIntents';

export function IntentManagementLayout() {
  const serialized = useDesign();

  return (
    <>
      <ListIntents serialized={serialized} />
      <Outlet />
    </>
  );
}
